<div class="alerts {{ alertType }}">
  <div>
    <div class="title-container">
      <div class="icon">
        <mat-icon *ngIf="alertType === 'warning'">warning</mat-icon>
        <mat-icon *ngIf="alertType === 'error'">error</mat-icon>
        <mat-icon *ngIf="alertType === 'info'">info</mat-icon>
      </div>
      <div class="title">{{ title }}</div>
    </div>
    <ng-container *ngFor="let message of params.messages">
      <div class="message">{{ message }}</div>
    </ng-container>
  </div>
</div>
<div class="action-button">
  <button mat-button [mat-dialog-close]="true">{{ buttonText }}</button>
</div>
